import { Menu, X } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { navItems } from "../data/homePageContent";
import { mailtoHref } from "../data/siteConfig";
import { BrandMark } from "./BrandMark";

export function Header() {
  /**
   * Narrow screens collapse the section links into a drawer, but never the account control: the whole
   * header used to be hidden below 980px, so a phone visitor had no way to reach the portal at all.
   * Sign in stays in the bar at every width and the hamburger owns only the marketing links.
   */
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (!menuOpen) return;
    function onKeyDown(event: KeyboardEvent) {
      if (event.key === "Escape") setMenuOpen(false);
    }
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [menuOpen]);

  const sectionLinks = (
    <>
      {navItems.map((item) => (
        <a key={item.href} href={item.href} onClick={() => setMenuOpen(false)}>
          {item.label}
        </a>
      ))}
    </>
  );

  return (
    <header className="site-header">
      <div className="site-shell site-header__inner">
        <a className="brand-link" href="#top" aria-label="Subedi Tax Pro home">
          <BrandMark />
          <span>Subedi Tax Pro</span>
        </a>
        <nav className="site-nav" aria-label="Primary navigation">
          <div className="site-nav__links">{sectionLinks}</div>
          {/*
            The only account entry point on the site. There is no separate sign-up: the portal
            provisions an account on first successful sign-in, so one destination serves returning
            and first-time clients alike. It points at /portal rather than /portal/sign-in so an
            already-restorable session lands straight on the dashboard.
          */}
          <Link className="button button--nav" to="/portal">
            Sign in
          </Link>
          <button
            className="site-nav__toggle"
            type="button"
            aria-expanded={menuOpen}
            aria-controls="site-nav-drawer"
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            onClick={() => setMenuOpen((open) => !open)}
          >
            {menuOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </nav>
      </div>
      {menuOpen && (
        <div className="site-nav__drawer" id="site-nav-drawer">
          <div className="site-shell site-nav__drawer-inner">{sectionLinks}</div>
        </div>
      )}
    </header>
  );
}
